import { flex, flexColumn } from 'hfty-styles/src/mixins'
import { primary, white } from 'hfty-styles/src/colors'

const CARD_WIDTH = 900
const CARD_HEIGHT = 655
const FIELDS_TABLE_MAX_HEIGHT = 250
const ITEMS_COMMON_INDENT = '19px'
const ITEMS_BORDER = `1px solid ${primary()}`

export const styles = {
  mainWrapper: {
    ...flex(),
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    opacity: 1,
    zIndex: 2,
    backgroundColor: 'rgba(0, 0, 0, 0.45)',
  },
  card: {
    width: CARD_WIDTH,
    maxHeight: CARD_HEIGHT,
    overflowY: 'scroll',
    padding: `${ITEMS_COMMON_INDENT} 85px`,
    backgroundColor: white(),
  },
  cardHeader: {
    paddingBottom: ITEMS_COMMON_INDENT,
    fontSize: 21,
    lineHeight: '100%',
    textAlign: 'center',
    color: 'rgb(99, 99, 99)',
  },
  farmAndSeasonSelectors: {
    boxSizing: 'border-box',
    width: '100%',
    marginBottom: ITEMS_COMMON_INDENT,
    padding: `${ITEMS_COMMON_INDENT} ${ITEMS_COMMON_INDENT} 5px`,
    border: ITEMS_BORDER,
  },
  seasonSelector: {
    ...flex('space-between'),
    marginBottom: 15,
  },
  select: {
    width: 250,
  },
  fieldsSelectorsTable: {
    ...flexColumn('flex-start'),
    width: '100%',
    maxHeight: FIELDS_TABLE_MAX_HEIGHT,
    overflowY: 'scroll',
    padding: `${ITEMS_COMMON_INDENT} 0 15px`,
    borderTop: ITEMS_BORDER,
    borderLeft: ITEMS_BORDER,
    borderRight: ITEMS_BORDER,
  },
  tableHeader: {
    marginBottom: ITEMS_COMMON_INDENT,
  },
  tableHeaderFirst: {
    paddingRight: 5,
    fontSize: 17,
    fontWeight: 'bold',
  },
  tableHeaderSecond: {
    fontSize: 17,
    color: primary(),
  },
  tableSegment: {
    textAlign: 'center',
  },
  tableDefSegment: {
    padding: '0 1.5rem 13px',
  },
  tableIdSegment: {
    padding: '0 2.5rem 13px',
  },
  tableLabelSegment: {
    padding: '0 5.5rem 13px',
  },
  tablePointsSegment: {
    padding: '0 0.5rem 13px',
  },
  fieldsSelectorsTableFooter: {
    ...flex(),
    width: '100%',
    padding: '15px 0',
    border: ITEMS_BORDER,
  },
  fieldsSelectorsTableButton: {
    width: 125,
    height: 35,
    backgroundColor: primary(),
    color: white(),
  },
  cardFooter: {
    ...flex(),
    width: '100%',
    marginTop: ITEMS_COMMON_INDENT,
  },
  cardFooterButton: {
    width: 130,
    height: 42,
    margin: '0 5px',
    backgroundColor: primary(),
    color: white(),
  },
  errors: {
    boxSizing: 'border-box',
    width: '100%',
    marginTop: ITEMS_COMMON_INDENT,
    padding: 10,
    border: '1px solid rgb(235, 175, 2)',
    background: 'rgb(252, 250, 228)',
  },
  errorsItem: {
    ...flex('flex-start'),
    margin: '10px 0',
    listStyle: 'dot',
    fontSize: 15,
  },
  errorItemKey: {
    paddingRight: 15,
  },
  errorItemBody: {
    color: 'red',
  },
  singleErrorBody: {
    display: 'block',
    padding: '10px 0 10px 5px',
    fontSize: 15,
    color: 'red',
  },
}
